import { AfterViewInit, Component, Input, OnInit } from '@angular/core';
import { takeUntil } from 'rxjs/operators';

// Classes
import { BaseFilter } from '@finder/shared/components/filters/classes/base-filter.class';
import { Facet } from '@finder/shared/services/filter-emitter-service/facet.class';
import { LocalStorageService } from '@finder/shared/services/local-storage/local-storage.service';
import { TopFilterButton } from '@finder/shared/components/filters/classes/top-filter-button.class';
// Services
import { FilterEmitterService } from '@finder/shared/services/filter-emitter-service/filter-emitter.service';
import { FinderAnalyticsService } from '@finder/shared/services/finder-analytics/finder-analytics.service';
import { ViewportDetectionService } from '@finder/shared/services/viewport-detection/viewport-detection.service';
import { CommonModule } from '@angular/common';
import { FilterButtonComponent } from '@finder/shared/components/filters/components/filter-button/filter-button.component';
import { FilterPillsComponent } from '@finder/shared/components/filters/components/filter-pills/filter-pills.component';

@Component({
    selector: 'finder-calendar-filters',
    templateUrl: './calendar-filters.component.html',
    styleUrls: ['./calendar-filters.component.scss'],
    standalone: true,
    imports: [
        CommonModule,
        FilterButtonComponent,
        FilterPillsComponent,
    ]
})
export class CalendarFiltersComponent extends BaseFilter implements OnInit, AfterViewInit {

    @Input() showFilters = true;

    isMobile = false;

    constructor(
        protected filterEmitterService: FilterEmitterService,
        protected finderAnalyticsService: FinderAnalyticsService,
        private viewportService: ViewportDetectionService,
        protected localStorageService: LocalStorageService
    ) {
        super(filterEmitterService, finderAnalyticsService, localStorageService);
    }

    ngOnInit() {
        super.ngOnInit();
        this.isMobile = this.viewportService.isMobile();
    }

    ngAfterViewInit() {
        super.ngAfterViewInit();

        this.viewportService.onViewportResize()
            .pipe(takeUntil(this.destroy$))
            .subscribe(() => {
                this.isMobile = this.viewportService.isMobile();
            });
    }

    handleWatchFacet(facet: Facet) {
        this.topFilters.forEach((filter: TopFilterButton) => this.setFilterState(filter, facet));
        this.applyFacet(facet);
    }
}
